import React, { FC } from 'react';
import RecipeStep, { RecipeStepProps } from '../../atoms/RecipeStep';
import * as SC from './styled';
export type RecipeStepsProps = {
  className?: string;
  title?: string;
  steps: RecipeStepProps[];
};
const RecipeSteps: FC<RecipeStepsProps> = ({
  className,
  title,
  steps
}) => {
  return <SC.Container className={className}>
      {title && <SC.Title>{title}</SC.Title>}
      <SC.Ingredients>
        {steps?.map((ingredient, i) => <SC.Step key={i}>
            <RecipeStep {...ingredient} />
          </SC.Step>)}
      </SC.Ingredients>
    </SC.Container>;
};
export default RecipeSteps;